export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9646.4e64a0db.jpg";